import { ICONS, URL_LABEL } from "../../../../../content/index.content";
import SVG_CHROME from "../../../../../../../../assets/images/vector/Layout/Header/logos/chrome.svg";

const proAiExtension = ({ language, isSavedUser }) => {
  return {
    title: "PRO AI Extension",
    subtitle:
      "Get extensive data on every Amazon item to find highly profitable products to sell",
    icon: ICONS.HOT,
    img: SVG_CHROME,
    href: isSavedUser
      ? `${process.env.SCOUT_EXT_PRO_NEW}?utm_source=site&utm_medium=amzscout&utm_campaign=menu`
      : `/pro-ai/?${URL_LABEL}`,
    isBlank: isSavedUser,
    isLink: !isSavedUser,
  };
};

export default proAiExtension;
